// Hero Section Heading Blur
window.addEventListener('scroll', function() {
    const heading = document.getElementById('heroTitle');
    const scrollPosition = 100;

    if (window.scrollY > scrollPosition) {
        heading.classList.add('blured');
    } else {
        heading.classList.remove('blured');
    }
});

// Onload Text Animation
document.addEventListener("DOMContentLoaded", function () {
    const animatedSection = document.getElementById("animated-section");

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function animateOnScroll() {
        if (isInViewport(animatedSection)) {
            animatedSection.classList.add("visible");
        }
    }

    window.addEventListener("scroll", animateOnScroll);

    // Initial check on load
    animateOnScroll();
});

// Add 'loaded' class to the animated section when page loads
window.addEventListener('load', () => {
    const animatedSection = document.getElementById('animated-section');
    if (animatedSection) {
        animatedSection.classList.add('loaded');
    }
});

// Scroll event listener for blur and parallax effect
window.addEventListener('scroll', () => {
    const textSection = document.getElementById('textSection');
    const parallaxImage = document.getElementById('parallaxImage');

    // Parallax effect
    const scrollY = window.scrollY;
    const translateYValue = -scrollY * 0.1; // Adjust multiplier for parallax speed
    if (parallaxImage) {
        parallaxImage.style.setProperty('--translateY', `${translateYValue}px`);
    }

    // Text section animation
    const sectionBottom = textSection.getBoundingClientRect().bottom;
    const windowHeight = window.innerHeight;

    if (sectionBottom - windowHeight < 100) {
        textSection.classList.add('scrolled');
    } else {
        textSection.classList.remove('scrolled');
    }
});




